import { CultureInfo } from '../culture-info.model';
import { CultureInfoZhHant } from './zh-Hant';

/**
 * @ignore
 */
export const CultureInfoZhHantHK: CultureInfo = {
  name: 'zh-Hant-HK',
  displayName: '繁體中文（香港）',
  iso3LanguageCode: 'zho',
  iso2LanguageCode: 'zh',
  ietfLanguageTag: 'zh-Hant-HK',
  parent: CultureInfoZhHant
};
